import { Container, Grid } from "@mui/material";
import WalletCards from "./components/WalletCards";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import useDispatch from "hooks/useDispatch";
import { getPortfolioBasketMenuViewList } from "store/slices/wallet/walletSlice";
import HistoryButton from "./components/HistoryButton";

export function Wallet() {
  const dispatch = useDispatch();

  const portfolioBasketMenu = useSelector(
    (state) => state.wallet.portfolioBasketMenu?.data
  );

  useEffect(() => {
    dispatch(getPortfolioBasketMenuViewList());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container maxWidth="100%">
      <Grid container mt={0} spacing={2}>
        <Grid
          item
          xs={12}
          textAlign="right"
        >
          <HistoryButton />
        </Grid>

        {portfolioBasketMenu?.map((item, index) => (
          <Grid item xs={6} md={3}>
            <WalletCards key={index} item={item} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default Wallet;
